import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * User taps 'next' after entering their email in the auth flow.
 */
const logSignUpModalEmailTapped = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('sign up modal email tapped', {}, callback);
};

export default logSignUpModalEmailTapped;
